module.exports = __webpack_public_path__ + "static/media/Search.6bb74127.svg";